import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { handleApiError } from "../handleApiError";
import axiosInstance from "../axiosInstance";

const API_URL = process.env.REACT_APP_API_URL + "/user";

export const getUsers = createAsyncThunk(
  "users/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();

      if (params.id) query.append("id", params.id);
      if (params.role) query.append("role", params.role);
      if (params.search) query.append("search", params.search);
      if (params.page) query.append("page", params.page);
      if (params.limit) query.append("limit", params.limit);
      if (params.sort) query.append("sort", params.sort);

      const response = await axiosInstance.get(`/user?${query.toString()}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getMyProfile = createAsyncThunk(
  "users/getMyProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/myProfile");

      return response.data;
    } catch (error) {
      toast.error("فشل تحميل الملف الشخصي");
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const addUser = createAsyncThunk(
  "users/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/user", data);

      toast.success("تم إضافة المستخدم بنجاح");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateUser = createAsyncThunk(
  "users/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/user/${id}`, data);

      toast.success("تم تحديث المستخدم");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteUser = createAsyncThunk(
  "users/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/user/${id}`);

      toast.success("تم حذف المستخدم");
      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const toggleUserBlock = createAsyncThunk(
  "users/toggleBlock",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/user/toggle-block/${id}`);
      // console.log(response);
      return id;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const editUserCoins = createAsyncThunk(
  "users/editCoins",
  async ({ id, coins }, { rejectWithValue }) => {
    try {
      // console.log(id, coins);
      const response = await axiosInstance.patch(`/user/edit-coins/${id}`, {
        coins,
      });

      toast.success("تم تعديل الكوينز");
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
